jQuery(function($){

	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();
	siteMenu();

	document.addEventListener('click', function(e) {
  const btn = e.target.closest('.email-reveal__btn');
  if (!btn) return;
  e.preventDefault();

  const wrap = btn.closest('.email-reveal');
  if (!wrap) return;

  const email = (wrap.dataset.user || '') + '@' + (wrap.dataset.domain || '');
  if (!email.includes('@')) return;

  const a = document.createElement('a');
  a.href = 'mailto:' + email;
  a.textContent = email;

  wrap.replaceWith(a);
});

	function siteMenu() {
		var window_width = jQuery(window).width();
		
		jQuery(".page-id-2 .internal a").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
          console.log(href);
		  var pos = 100;
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  
		});
		
  
		jQuery(".page-id-3953 .internal-en a").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
		  var pos = 70;
		  var href = href.replace("en/", "");
		
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  if (window_width < 768) {
		  jQuery('#hamburger').removeClass('open');
		  jQuery('.site-header__navigation ul').slideUp(400);
		  }
		});
	  }

    if (window.location.hash) {
		console.log('hash');
        const targetId = window.location.hash; // Pobierz hash (np. #section1)
        const $target = $(targetId); // Znajdź element o podanym ID

        if ($target.length) {
            // Jeśli element istnieje, przewiń do niego z offsetem -200px
            $('html, body').animate({
                scrollTop: $target.offset().top -100
            }, 500); // Animacja przewijania trwa 500ms
        }
    }

	$(function(){
        loopcounter('myCountdown');
    });
	function goTo() {

    $(".go-to").click(function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        var pos = -100;
        jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top + pos
        }, 500);
        });
    }

    function inifFancybox() {
        Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        loop : true,

        afterClose: function(instance, current) {
            var videos = document.querySelectorAll('.inline-movies');

            videos.forEach(function(video) {
                video.pause();
            });
        }
        });
    }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1024) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
			});
			
			$('.menu-item-has-children').on('click', function(event) {
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
				}
			});
		}
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {
            $("header").addClass("scrolled");
        
        } else {
            $("header").removeClass("scrolled");
        }

    });

	function blockSlider() {

		jQuery('.header-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ['<svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="67" height="67" rx="3" stroke="white" stroke-width="2"/><path d="M27.0777 32.4019L25.8827 33.5969L27.5727 33.5969L46.224 33.5969L46.224 35.3761L27.5738 35.3772L25.8839 35.3773L27.0788 36.5721L35.1106 44.6039L33.8522 45.8623L22.4764 34.4865L33.8522 23.1106L35.1106 24.369L27.0777 32.4019Z" fill="white" stroke="#F6F7F8" stroke-width="1.4"/></svg>','<svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="68" y="68" width="67" height="67" rx="3" transform="rotate(-180 68 68)" stroke="white" stroke-width="2"/><path d="M41.9223 36.5981L43.1173 35.4031L41.4273 35.4031L22.776 35.4031L22.776 33.6239L41.4262 33.6228L43.1161 33.6227L41.9212 32.4279L33.8894 24.3961L35.1478 23.1377L46.5236 34.5135L35.1478 45.8894L33.8894 44.631L41.9223 36.5981Z" fill="white" stroke="#F6F7F8" stroke-width="1.4"/></svg>'],
			autoplayHoverPause:true
		});

        jQuery('.portfolio-slider').owlCarousel({
            loop:true,
            margin:42,
            nav:true,
            items:1,
            autoplay:true,
            autoplayTimeout:3000,
            autoplaySpeed: 1000,
            slideSpeed: 1000,
            navSpeed: 1000,
            dotsSpeed: 1000,
            dots: false,
            singleItem: true,
            
            navText: ['<svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="67" height="67" rx="3" stroke="white" stroke-width="2"/><path d="M27.0777 32.4019L25.8827 33.5969L27.5727 33.5969L46.224 33.5969L46.224 35.3761L27.5738 35.3772L25.8839 35.3773L27.0788 36.5721L35.1106 44.6039L33.8522 45.8623L22.4764 34.4865L33.8522 23.1106L35.1106 24.369L27.0777 32.4019Z" fill="white" stroke="#F6F7F8" stroke-width="1.4"/></svg>','<svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="68" y="68" width="67" height="67" rx="3" transform="rotate(-180 68 68)" stroke="white" stroke-width="2"/><path d="M41.9223 36.5981L43.1173 35.4031L41.4273 35.4031L22.776 35.4031L22.776 33.6239L41.4262 33.6228L43.1161 33.6227L41.9212 32.4279L33.8894 24.3961L35.1478 23.1377L46.5236 34.5135L35.1478 45.8894L33.8894 44.631L41.9223 36.5981Z" fill="white" stroke="#F6F7F8" stroke-width="1.4"/></svg>'],
			autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
				stagePadding: 50,
                },
                960:{
                items:2,
				stagePadding: 150,
                },
                
                1440:{
                    items:3,
                    stagePadding: 160,
                },

				1900:{
                    items:3,
                    stagePadding: 300,
                },
                
            }
        });
    }

})